import script from "./aiorder_step2.vue?vue&type=script&setup=true&lang=js"
export * from "./aiorder_step2.vue?vue&type=script&setup=true&lang=js"

import "./aiorder_step2.vue?vue&type=style&index=0&id=6fdb05c5&lang=css"

const __exports__ = script;

export default __exports__